/**
 * ★ Fase 68/69 — Video racconto Verification Pass Albania (edizione 9–11 ott 2026)
 * nelle landing dedicate Narea / Three Garden (IT · ES · EN).
 */
import React from 'react';

const VIDEO_ID = 'gBdZ_-Y2s6w';
const TXT = {
  it: { kicker: 'Verification Pass · dal vivo', title: 'Dallo schermo alla realtà: tre giorni con HCF in Albania' },
  es: { kicker: 'Verification Pass · en directo', title: 'De la pantalla a la realidad: tres días con HCF en Albania' },
  en: { kicker: 'Verification Pass · live', title: 'From screen to reality: three days with HCF in Albania' },
};

export function VpRecapVideo({ lang = 'it', dark = false, accent = '#D6B25E', testId = 'vp-recap-video', className = '' }) {
  const t = TXT[lang] || TXT.it;
  return (
    <div className={`max-w-4xl mx-auto ${className}`} data-testid={testId}>
      <div className="text-[11px] font-bold uppercase tracking-[0.22em]" style={{ color: accent }}>{t.kicker}</div>
      <div className={`mt-2 font-serif text-xl sm:text-2xl leading-tight ${dark ? 'text-[#FFF7EE]' : ''}`}>{t.title}</div>
      <div className="mt-4 rounded-2xl overflow-hidden border aspect-video" style={{ borderColor: `${accent}66`, boxShadow: '0 20px 60px rgba(0,0,0,0.35)' }}>
        <iframe
          src={`https://www.youtube.com/embed/${VIDEO_ID}?rel=0&modestbranding=1`}
          title={t.title}
          className="w-full h-full"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
}
